/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';

export default function ShowRtSummary(props)
{
    const [showRtSummary, setShowRtSummary] = useState(false);

    /** Set activity panel to value being passed through props */
    useEffect(() => {
        setShowRtSummary(props.value);
    },[props.value]);
    
    /**Handle changes to activity panel checkbox */
    const handleShowRtSummary = () => {
        setShowRtSummary(!showRtSummary);
        props.onChange(!showRtSummary)
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={showRtSummary}
                        onChange={handleShowRtSummary}
                        name="Show RTIG"
                        color="primary"
                        />
                    }
                    label="Show Real Time Summary"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Show the Real Time Summary widget">
                        <AssignmentIndOutlinedIcon color="primary"/>
                    </Tooltip>
                </Grid>
            </Grid>
        </div>
    );
}

